function resolvePageUrl(dataUrl) {
    if (dataUrl && dataUrl.charAt(0) === '?') {
        return `${window.location.origin}${window.location.pathname}${dataUrl}`;
    }

    return dataUrl || window.location.href;
}

function shareViaEmail(pageUrl) {
    const encodedSubject = encodeURIComponent('Check out this webpage!');
    const encodedBody = encodeURIComponent(
        `I thought you might find this interesting: ${pageUrl}`
    );

    window.location.href = `mailto:?subject=${encodedSubject}&body=${encodedBody}`;
}

function socialShareUrl(network, pageUrl) {
    const encoded = encodeURIComponent(pageUrl);

    if (network === 'linkedin') {
        return `https://www.linkedin.com/sharing/share-offsite/?url=${encoded}`;
    }

    if (network === 'facebook') {
        return `https://www.facebook.com/sharer/sharer.php?u=${encoded}`;
    }

    return pageUrl;
}

function setShareStatus(trigger, message) {
    const share = trigger.closest('.news-item__share');
    const status = share && share.querySelector('[data-news-share-status]');

    if (!status) {
        return;
    }

    status.textContent = message;
    window.setTimeout(function clearShareStatus() {
        status.textContent = '';
    }, 2000);
}

function copyLink(pageUrl, trigger, message) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(pageUrl).then(function onCopied() {
            setShareStatus(trigger, message);
        });
        return;
    }

    setShareStatus(trigger, message);
}

export default function _newsItemShare() {
    document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-news-share]');

        if (!trigger) {
            return;
        }

        event.preventDefault();

        const pageUrl = resolvePageUrl(trigger.getAttribute('data-url'));
        const type = trigger.getAttribute('data-news-share');

        if (type === 'email') {
            shareViaEmail(pageUrl);
            return;
        }

        if (type === 'linkedin' || type === 'facebook') {
            window.open(
                socialShareUrl(type, pageUrl),
                '_blank',
                'noopener,noreferrer'
            );
            return;
        }

        if (type === 'instagram' || type === 'copy') {
            copyLink(pageUrl, trigger, 'Link copied');
        }
    });
}

_newsItemShare();
